import(/* webpackMode: "eager" */ "/workspace/app/api-playground/page.tsx");
